/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { UnitCategory } from '@src/app/model/unit-category';
import { UnitType } from '@src/app/model/unit-type';

export class ScheduleCriteria extends AbstractObject {
  scheduleId: uuid;
  type: UnitType;
  typeId: uuid;
  category: UnitCategory;
  categoryId: uuid;
  include = true;
  portion = 1;
  matches?: number;
  constructor(o: Partial<ScheduleCriteria> = {}) {
    super(o);
  }
}
